import {DailyTransactionTypeEnum} from "../../../../../models";
import {useTransactionInitializationStore} from "../../stores/useTransactionInitializationStore";
import {useCallback, useEffect} from "react";

interface UseTransactionInitializationProps {
    transactionType: DailyTransactionTypeEnum;
    formId: number;
    // autoLoad?: boolean;
    // onLoadComplete?: (success: boolean) => void;
    // onError?: (error: string) => void;
}
export const useTransactionInitializationContext = ({
                                                 transactionType,
                                                 formId,
                                             }: UseTransactionInitializationProps) => {
    //#region state & hooks
    const store = useTransactionInitializationStore();
    const {
        beneficiaryList,
        originalBeneficiaryList,
        categoryList,
        itemList,
        itemsPerCategoryList,
        paymentTypeList,
        currencyList,
        storeEmployeeList,
        costCenterList,
        calcTypeList,
        storeList,
        isSalesComponent,
        hasSingleStore,
        defaultStoreId,
        loading,
        isLoaded,
        initialize,
        resetState,
    } = store;
    //#endregion
    //#region functions
    const initializeData = useCallback(async () => {
        try {
            await initialize(transactionType, formId);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to initialize';
            console.error('Custom hook initialization failed:', err);
        }
    }, [transactionType, formId]);
    const reset = useCallback(() => {
        resetState();
    }, []);
    //#endregion
    //#region useEffect
    useEffect(() => {
            initializeData().then(() => {});
    }, [transactionType]);
    //#endregion
    //#region return
    return {
        transactionType,
        formId,
        beneficiaryList,
        originalBeneficiaryList,
        categoryList,
        itemList,
        itemsPerCategoryList,
        paymentTypeList,
        currencyList,
        storeEmployeeList,
        costCenterList,
        calcTypeList,
        storeList,
        isSalesComponent,
        hasSingleStore,
        defaultStoreId,
        initialize: initializeData,
        reset,
        loading,
        isLoaded,
    }
    //#endregion
};